import { createElement } from "../Helpers/createElement";

export const initPrintHandlers = () => {
    const createBibliography = () => {
        const contentLinks = document.querySelectorAll('.order-lg-2 a, .body-copy a, .tile a, .box-blog a') as NodeListOf<HTMLAnchorElement>;
        const excludedPrefixes = ['#', 'tel:', 'mailto:'];
        const allLinks = [...contentLinks].reduce((accumulator, link) => {
            let hrefAttribute = link.getAttribute('href');
            
            if (hrefAttribute && !excludedPrefixes.some(prefix => hrefAttribute?.startsWith(prefix))) {
                if (hrefAttribute.startsWith('/')) {
                    hrefAttribute = `${window.location}${hrefAttribute}`;
                }

                if (!accumulator.some(existingUrl => existingUrl.url === hrefAttribute)) {
                    accumulator = [...accumulator, { url: hrefAttribute, linkText: link.innerText }];
                }
            }

            return accumulator;
        }, [] as {url: string, linkText: string}[]);
    
        if (allLinks.length) {
            const pageElement = document.getElementById('page') as HTMLDivElement | null;

            pageElement?.appendChild(createElement('div', {
                id: 'PrintedBibliography',
                children: [
                    createElement('h2', {
                        innerText: 'Page Links'
                    }),
                    createElement('ol', {
                        children: allLinks.map(link => createElement('li', { innerText: link.linkText ? `${link.linkText} - ${link.url}` : link.url }))
                    })
                ]
            }))
        }
    };

    const beforePrint = () => {
        const bibliography = document.getElementById('PrintedBibliography') as HTMLDivElement | null;

        if (bibliography) {
            bibliography.style.removeProperty('display');
        } else {
            createBibliography();
        }
    };

    const afterPrint = () => {
        const bibliography = document.getElementById('PrintedBibliography') as HTMLDivElement | null;
        if (bibliography) {
            bibliography.style.display = 'none';
        }
    };

    if (window.matchMedia !== undefined) {
        const mediaQueryList = window.matchMedia('print');
        mediaQueryList.addEventListener('change', mql => mql.matches ? beforePrint() : afterPrint);
    }

    if (window.onbeforeprint !== undefined) {
        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;
    }
};